const namespaced = true
import api from '../../../../api/sap/payment/prebatchs.js';
//import { downloadFile } from '../../../../src/helpers/util.js'

const state = {
    loadingReport: false,
    reportResult: [],
    loadingDocument: false,
    dialogValueInvoice: false,
    dialogConfirmationValue: false,
    selectedLote: null,
    invoicesResult: [],
    total_pago_pendiente: 0,
    loadingBatch: true,
    deleteInvoicesConfirmation: false,
    contInvoices: 0,
    invoicesID: [],
}
const mutations = {
    //Para obtener los lotes
    SET_DATA_RESULT(state, value) {
        state.reportResult = value;
    },

    //Para cuando el loadindg de la tabla de lotes este cargando 
    SET_LOADING_REPORT(state, value) {
        state.loadingReport = value;
    },

    //Boleano para mostrar el v-dialog de la tabla de facturas
    SET_DIALOG_STATE(state, value) {
        state.dialogValueInvoice = value;
    },

    //Boleano para mostrar el v-dialog de la confirmacion de aprobar factra
    SET_DIALOG_CONFIRMATION_STATE(state, value) {
        state.dialogConfirmationValue = value;
    },

    //Para pasar el numero de lote entre diferentes componentes directamente en el store
    SET_SELECTED_LOTE(state, value) {
        state.selectedLote = value;
    },

    //Para ontner un lote en especifico con sus facturas
    SET_INVOICES_BY_BATCH(state, value) {
        state.invoicesResult = value;
    },

    //Calcula el total de pago pendiente de un lote cuando se descarta una factura o se agrega una que se habia descartado
    SET_TOTAL_PENDIENTE_PAGO(state, value) {
        state.total_pago_pendiente = value;
    },

    //Sirve para pantalla de carga del v-dialog principal
    SET_LOADING_BATCH(state, value) {
        state.loadingBatch = value;
    },

    //Para el v-dialog de confirmacion de elimnacion de facturas, lo hace true o false 
    SET_DIALOG_DELETE_INVOICES(state, value) {
        state.deleteInvoicesConfirmation = value;
    },

    /*
    Las suiguientes tres funciones suman o restan un contador de las factras que seran eliminadas 
    y la ultima funcion es para asignarle un valor de 0 en caso de cerrar o abirir otro lote
     */
    SET_COUNT_PLUS_INVOICES(state) {
        state.contInvoices--;
    },
    SET_COUNT_REST_INVOICES(state) {
        state.contInvoices++;
    },
    RESTART_COUNT_INVOICES(state, value) {
        state.contInvoices = value;
    },

    /*
    Los siguientes dos SET van agregando o quitando ID's a un arreglo para hacer la query de eliminarlos, el tercer SET es para elimianr todos los ID's
     */
    SET_PUSH_INVOICES_ID(state, value) {
        state.invoicesID.push(value);
    },
    SET_REMOVE_INVOICES_ID(state, value) {
        const index = state.invoicesID.indexOf(value);
        state.invoicesID.splice(index, 1)
    },

    RESTART_INVOICES_ID(state, value) {
        state.invoicesID = value;
    },

}

const actions = {
    //Funcion para obtener los datos de la tabla de reportes
    async getReportBatch(context) {
        context.commit('SET_LOADING_REPORT', true);
        const lotes = await api.getReport();
        context.commit('SET_DATA_RESULT', lotes.data.result);
        context.commit('SET_LOADING_REPORT', false);
        return lotes.data.result;
    },

    /*
    Las siguientes funciones son para abrir o cerrar el v-dialog principal asignando su valor true o false
     */
    changeDialogValueTrue(context) {
        context.commit('SET_DIALOG_STATE', true);
    },
    changeDialogValueFalse(context) {
        context.commit('SET_DIALOG_STATE', false);
    },

    /*
    Las sigueintes 2 funciones son para el dialogo de confirmacion de aprobar un lote en review, cambian su valor true o false para que se abra o se cierre
     */
    changeConfirmationDialogTrue(context) {
        context.commit('SET_DIALOG_CONFIRMATION_STATE', true);
    },
    changeConfirmationDialogFalse(context) {
        context.commit('SET_DIALOG_CONFIRMATION_STATE', false);
    },

    /*
    Esta funcion pasa el # de lote al comoponente de v-dilog principal y se muestre en la vista, tambien sirve para hacer la query de obtener las facturas con el # de lote
     */
    passValue(context, value) {
        context.commit('SET_SELECTED_LOTE', value);
    },

    /*
    API para obtener las facturas de un lote
    */
    async getInvoices(context, value) {
        context.commit('SET_LOADING_BATCH', false);
        const invoices = await api.getReportInvoices(value);

        context.commit('SET_INVOICES_BY_BATCH', invoices.data.result);

        let totalPendiente = invoices.data.result.reduce((total, item) => {
            return total + parseFloat(item.pendiente_pago);
        }, 0);

        context.commit('SET_TOTAL_PENDIENTE_PAGO', totalPendiente);
        context.commit('SET_LOADING_BATCH', true);
        return invoices.data.result;
    },

    setEmptyInvoices(context) { //El contador de las facturas a que se eliminaran se vacia para abrir otro lote
        context.commit('SET_INVOICES_BY_BATCH', []);
        context.commit('RESTART_COUNT_INVOICES', 0);
    },

    /*
    Las siguientes dos funciones son las que suman o restan el pago pendiente de las facturas y adicional calculan
    la cantidad de facturas que se van a descartar, para mostrar el mensaje de "¿Confirmar la elimincion de {{ contInvoices }} factura(s)?"
    */
    restInvoice(context, value) {
        context.commit('SET_COUNT_REST_INVOICES');
        context.commit('SET_TOTAL_PENDIENTE_PAGO', Math.abs(value.total - value.invoivePrice));
    },
    plusInvoice(context, value) {
        context.commit('SET_COUNT_PLUS_INVOICES');
        context.commit('SET_TOTAL_PENDIENTE_PAGO', Math.abs(value.total + value.invoivePrice));
    },

    /*
    Las sigueintes dos funciones hacen, que el v-dialog de confirmacion de eliminacion de facturas 
    sea true o false
    */
    changeDeleteInvoicesTrue(context) {
        context.commit('SET_DIALOG_DELETE_INVOICES', true);
    },
    changeDeleteInvoicesFalse(context) {
        context.commit('SET_DIALOG_DELETE_INVOICES', false);
    },

    /*
    Las siguientes 3 funciones agregan y eliminan un ID de una factura de un arreglo que hara la query de elimanr
    la tercera funcion vacia ese arreglo al borrar las facturas o ver otro lote.
    */
    pushInvoices(contex, data) {
        contex.commit('SET_PUSH_INVOICES_ID', data);

    },
    removeInvoices(contex, data) {
        contex.commit('SET_REMOVE_INVOICES_ID', data);
    },
    deleteIAllnvoices(contex) {
        contex.commit('RESTART_INVOICES_ID', []);
    },

    //API paera elinar las facturas de un lote 🥳
    async deleteInvoicesFromBatch(context, data) {
        //commit  set para loading, true
        try {
            let valuesArray = Object.values(data);
            console.log(valuesArray.length);
            if (valuesArray.length === 0) { 
                // Opcional: notificación si no hay facturas a eliminar
                context.dispatch("notifications/add", { color: "warning", visibility: true, timeout: 3000, text: 'No se seleccionaron facturas para eliminar.', }, { root: true });
                return; // No se ejecuta la API
            }
            await api.deleteInvoces(valuesArray);
            context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: 'Facturas eliminadas correctamente', }, { root: true });
        } catch (error) {
            context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: 'Ocurrió un error al eliminar las facturas', }, { root: true });
        }
    },

    async aceptBatch(context, data){
        
        try {
            await api.aprovedBatch(data);
            context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: 'Lote aprobado correctamente', }, { root: true });
        } catch (error) {
            context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: 'Ocurrió un error al aprobar el lote', }, { root: true });
        }
    }


}
const getters = {

    getReport(state) {
        return state.reportResult;
    },

    getReportInvoices(state) {
        return state.invoicesResult;
    }
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
